import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Time from "react-time-format";

class FormPrint extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { RP_dataPara } = value;

            const wakil = RP_dataPara.map((user, i) => {
              return (
                <tr
                  key={i}
                  className="f4 fk"
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black"
                  }}
                >
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    <NumberFormat
                      value={user.rejaDinar.toFixed(2)}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    <NumberFormat
                      value={user.rejaDolar.toFixed(2)}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.phone}
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.Name}
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.code}
                  </td>
                </tr>
              );
            });

            return (
              <table id="example" className="table table-striped  text-right ">
                <thead>
                  <tr
                    className="text-black f3 fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black"
                    }}
                  >
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      ID ڕەسید بە
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      $ ڕەسید بە
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      تەلەفۆن
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      ناوی وەکیل
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      کۆد
                    </th>
                  </tr>
                </thead>
                <tbody>{wakil}</tbody>
              </table>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormPrint;
